import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { createElement } from 'react';

import { InvoiceV2ListPage } from '~/modules/invoice/v2/list/InvoiceV2ListPage';

import { i18n } from '~/utils';
import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';
import { getRouteHead } from '~/utils/routeUtils';

import { AlphaBadge } from '~/ui/molecules/AlphaBadge';

import { routeParams } from './-routeParams';
import {
  defaultInvoiceV2ListSearch,
  validateInvoiceV2ListSearch,
} from './-searchParams';

const title = i18n.t(($) => $.pageTitle.incoming, { ns: 'invoice' });

export const Route = createFileRoute('/(main)/invoices/v2/incoming/')({
  beforeLoad: createProtectedRoute({
    routePath: '/invoices/v2/incoming/',
    ...routeParams,
  }),
  component: () => createElement(InvoiceV2ListPage),
  head: () => getRouteHead(title),
  search: {
    middlewares: [stripSearchParams(defaultInvoiceV2ListSearch)],
  },
  staticData: {
    AppBar: {
      CustomComponent: AlphaBadge,
      title,
    },
  },
  validateSearch: validateInvoiceV2ListSearch,
});

export const V2_INCOMING_INVOICES = buildRouteExport({
  Route,
  ...routeParams,
});
